import React from "react";
import SelectOption from "./components/SelectOption";
import SelectOptionOther from "./components/SelectOptionOther";

function SelectCosmeticPropyleneOxide({
  selectedValue,
  onSelect,
  isReadonly,
  screenWidth,
}) {
  return (
    <div className="w-full h-full border border-solid border-[#B3B3B3] bg-white rounded-[10px]">
      <div>
        <div className="w-full h-full grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 items-center justify-center gap-2.5 py-2 px-2">
          <SelectOption
            label="液状"
            value="液状"
            onSelect={onSelect}
            isSelected={selectedValue === "液状"}
            isReadonly={isReadonly}
          />
          <SelectOption
            label="半固体"
            value="半固体"
            onSelect={onSelect}
            isSelected={selectedValue === "半固体"}
            isReadonly={isReadonly}
          />
          <SelectOption
            label="粉体"
            value="粉体"
            onSelect={onSelect}
            isSelected={selectedValue === "粉体"}
            isReadonly={isReadonly}
          />
          <SelectOption
            label="固体"
            value="固体"
            onSelect={onSelect}
            isSelected={selectedValue === "固体"}
            isReadonly={isReadonly}
          />
          <SelectOptionOther
            selectedValue={selectedValue}
            onSelect={onSelect}
            isReadonly={isReadonly}
            otherPrefix="シート状（厚さ）"
            inputWidth={screenWidth < 640 ? 1 : 2}
            inputPlaceholder="㎜"
          />
          <SelectOptionOther
            selectedValue={selectedValue}
            onSelect={onSelect}
            isReadonly={isReadonly}
            otherPrefix="その他"
            inputWidth={screenWidth < 640 ? 1 : 2}
          />
        </div>
        <div className="p-2 self-start text-xs text-[#707070]">
          ※シート状（不織布含む）は厚さ(㎜)、その他は詳細のご記載をお願いします。
        </div>
      </div>
    </div>
  );
}

export default SelectCosmeticPropyleneOxide;
